module.exports = __webpack_public_path__ + "static/media/partner-logos-4.85d0ae22.png";